import React from "react";
import { motion } from "framer-motion";

// Grid Background Component
const GridBackground = () => (
  <div
    className="fixed inset-0 w-full h-full overflow-hidden"
    style={{ zIndex: -1, backgroundColor: "#000000" }}
  >
    <div
      className="absolute inset-0 opacity-20"
      style={{
        backgroundImage: `url("data:image/svg+xml,%3csvg width='40' height='40' xmlns='http://www.w3.org/2000/svg'%3e%3cdefs%3e%3cpattern id='grid' width='40' height='40' patternUnits='userSpaceOnUse'%3e%3cpath d='m 40 0 l 0 40 m -40 0 l 40 0' fill='none' stroke='%23dcff02' stroke-width='0.5' opacity='0.3'/%3e%3c/pattern%3e%3c/defs%3e%3crect width='100%25' height='100%25' fill='url(%23grid)' /%3e%3c/svg%3e")`,
      }}
    />

    <motion.div
      className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full blur-[120px]"
      style={{ backgroundColor: "#dcff0230" }}
      animate={{
        scale: [1, 1.1, 1],
        opacity: [0.3, 0.5, 0.3],
      }}
      transition={{
        duration: 8,
        repeat: Infinity,
        repeatType: "reverse",
      }}
    />

    <motion.div
      className="absolute -bottom-40 -left-40 w-[500px] h-[500px] rounded-full blur-[100px]"
      style={{ backgroundColor: "#899901330" }}
      animate={{
        scale: [1, 1.2, 1],
        opacity: [0.3, 0.6, 0.3],
      }}
      transition={{
        duration: 10,
        repeat: Infinity,
        repeatType: "reverse",
        delay: 1,
      }}
    />
  </div>
);

export default GridBackground;
